import React from 'react';
import styled from 'styled-components';
import {
    Eyebrow,
    SubnavItemNumber,
    Typography as Text,
    VerticalSpacer,
    TextColorProps
} from '../../elements';
import {AnimateOnViewWrap} from '../../wraps/animation';

export interface SubnavSectionNameProps extends TextColorProps {
    index?: number | null;
    sectionName?: string;
    sectionNameAlign?: 'left' | 'center' | 'right';
    itemNumberColorOverride?: string;
    disableAnim?: boolean;
}

const Styled = styled.div``;

export const SubnavSectionName = ({
    accentColor,
    index,
    sectionName,
    sectionNameAlign = 'left',
    itemNumberColorOverride = '',
    disableAnim
}: SubnavSectionNameProps): JSX.Element | null => {
    if (!sectionName) return null;

    return (
        <Styled className="section-name">
            <AnimateOnViewWrap translateY={30} disable={disableAnim}>
                <Eyebrow align={sectionNameAlign}>
                    <SubnavItemNumber big index={index} colorOverride={itemNumberColorOverride} />
                    <Text variant="h4" big color={accentColor}>
                        {sectionName}
                    </Text>
                </Eyebrow>
                <VerticalSpacer variant="heading" />
            </AnimateOnViewWrap>
        </Styled>
    );
};
